/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Neighborhood_DescriptionInputs */

const en_meta_showcase_neighborhood_description = /** @type {(inputs: Meta_Showcase_Neighborhood_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An interactive area guide of nearby restaurants, museums and transit that keeps guests on your own site. Live demo of the neighbourhood module.`)
};

const lv_meta_showcase_neighborhood_description = /** @type {(inputs: Meta_Showcase_Neighborhood_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interaktīva apkārtnes karte ar restorāniem, muzejiem un transportu, lai viesi atrastu vajadzīgo Jūsu mājaslapā. Apkārtnes moduļa demonstrācija viesnīcām.`)
};

/**
* | output |
* | --- |
* | "An interactive area guide of nearby restaurants, museums and transit that keeps guests on your own site. Live demo of the neighbourhood module." |
*
* @param {Meta_Showcase_Neighborhood_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_neighborhood_description = /** @type {((inputs?: Meta_Showcase_Neighborhood_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Neighborhood_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_neighborhood_description(inputs)
	return en_meta_showcase_neighborhood_description(inputs)
});